"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./HeroSection.css";
import heroImg from "../../../assets/images/herosection.jpeg";

import { ROUTES } from "../../../routes/patientRoutes/routePaths";
import { DOCTOR_ROUTES } from "../../../routes/patientRoutes/routePaths";
import { ASSISTANT_ROUTES } from "../../../routes/patientRoutes/routePaths";

export default function HeroSection() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("landingPage");

  const currentLang = i18n.language?.split("-")[0] || "en";
  const isArabic = currentLang === "ar";

  useRevealOnScroll([currentLang]);

  const statsRaw = t("hero.stats", { returnObjects: true });
  const stats = Array.isArray(statsRaw) ? statsRaw : [];

  return (
    <section className="hero-wrapper" id="home">
      <div
        className={`hero reveal-on-scroll reveal-fade ${
          isArabic ? "hero--rtl" : ""
        }`}
        key={currentLang}
      >
        <div className="hero__bg">
          <img src={heroImg} alt="" className="hero__bg-img" />
          <div className="hero__bg-overlay" />
        </div>

        <div className="hero__body">
          <div className="hero__text reveal-on-scroll reveal-left">
            <h1 className="hero__title">
              {t("hero.title.line1")}
              <br />
              {t("hero.title.line2")} <span>{t("hero.title.accent1")}</span>
              <br />
              <span>{t("hero.title.accent2")}</span>
            </h1>

            <p className="hero__subtitle">{t("hero.subtitle")}</p>

            <div className="hero__actions">
              <button
                className="hero__btn-outline"
                type="button"
                onClick={() => navigate(ROUTES.LOGIN)}
              >
                {t("common.patient")}
                <span className="hero__btn-circle">→</span>
              </button>

              <button
                className="hero__btn-outline"
                type="button"
                onClick={() => navigate(DOCTOR_ROUTES.LOGIN)}
              >
                {t("common.doctor")}
                <span className="hero__btn-circle">→</span>
              </button>

              <button
                className="hero__btn-outline"
                type="button"
                onClick={() => navigate(ASSISTANT_ROUTES.LOGIN)}
              >
                {t("common.assistant")}
                <span className="hero__btn-circle">→</span>
              </button>
            </div>

            <p className="hero__free-note">{t("hero.freeNote")}</p>
          </div>

          <div className="hero__stats reveal-on-scroll reveal-right">
            <div className="hero__stats-row">
              {stats.slice(0, 2).map((s, index) => (
                <div
                  key={`${s.value}-${index}`}
                  className="hero__stat-card reveal-on-scroll reveal-card"
                  style={{ transitionDelay: `${index * 90}ms` }}
                >
                  <span className="hero__stat-val">{s.value}</span>

                  <span className="hero__stat-label">
                    {String(s.label)
                      .split("\n")
                      .map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                  </span>
                </div>
              ))}
            </div>

            {stats.slice(2).map((s, index) => (
              <div
                key={`${s.value}-${index}`}
                className="hero__stat-card hero__stat-card--wide reveal-on-scroll reveal-card"
                style={{ transitionDelay: `${(index + 2) * 90}ms` }}
              >
                <span className="hero__stat-val">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}